const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default class NewsletterModal {


  // Constructor
  constructor(element, footerForm) {
    this.element = element;
    this.footerForm = footerForm;

    this.submitFooterForm = this.submitFooterForm.bind(this)
    this.footerForm.addEventListener('submit', this.submitFooterForm)

    this.popupClickHandler = this.popupClickHandler.bind(this)
    this.popupOverlayCloseHandler = this.popupOverlayCloseHandler.bind(this)

    this.element.addEventListener('mousedown', this.popupOverlayCloseHandler)
  }

  submitFooterForm(e) {
    e.preventDefault();
    let footerEmailValue = this.footerForm.querySelector('input[name="footer_email"]').value
    let modalEmailFields = Array.prototype.slice.call(this.element.querySelectorAll('input[type="email"]'), 0)
    modalEmailFields.forEach(modalEmailField => modalEmailField.value = footerEmailValue)
    this.open()
  }

  open() {
    this.element.classList.add('show')
    disableBodyScroll(this.element)
  }

  close() {
    this.element.classList.remove('show')
    enableBodyScroll(this.element)
  }

  closeClickHandler(e) {
    this.close()
  }

  popupClickHandler(e) {
    e.stopPropagation();
  }

  popupOverlayCloseHandler(e) {
    
    if (e.target.closest('.newsletter-modal--popup')) {
      return;
    }

    this.close()
  }

  // Public Methods
  resize() {
  }
}
